/**
 * main_validate.js - SMS認証を行うページのバリデーションを行う
 *     対象チケット : MYSB-1396
 *     build対象
 */

/**
 * errorMessageObj - エラー文言をつめている連想配列です
 * @type {Object}
 */
var errorMessageObj = require('./error_message');

/**
 * SMS_AUTH - SMS認証バリデーション周りのメソッド等をつめる連想配列です
 * @type {Object}
 */
var SMS_AUTH = {};

SMS_AUTH.field = {
	/**
	 * SMS_AUTH.field.init - コンストラクタです。
	 *    ラジオボタンのリアルタイムバリデーション（必須チェック）を登録しています。
	 */
	init: function() {
		//ラジオボタンはfocusoutイベントで拾えないので、changeイベントでリアルタイムバリデーションをする
		$('input[type=radio]').on('change', function(event) {
			SMS_AUTH.field.observe(event);
		});

	},

	/**
	 * SMS_AUTH.field.validatePage - form内の全fieldに対して
	 *    必須チェックと形式チェックをするための関数です。
	 * @param {object}    window.event
	 * @return {Boolean}  エラーがなければtrue
	 */
	validatePage: function(event) {
		SMS_AUTH.field.deleteErrorMessageAll();
		SMS_AUTH.field.validateAll();

		if ($('.validate-support-area').length > 0) {
			var $radioName = $('.support-project-area').find('[type=radio]').eq(0).attr('name');
			var $radioBox = $('input[name=' + $radioName + ']');

			SMS_AUTH.field.validateSupportArea();
		}

		if ($('.error').length !== 0) {
			event.preventDefault();
			SMS_AUTH.field.scrollErrorTop();
			return false;
		}
		return true;
	},

	observe: function(event) {
		var $target = $(event.target);
		var $targetItem = $(event.target).closest('.item');
		var $targetTxtError = $(event.target).closest('.item').find('.txtError');

		if ($('.js-validate:hover').length > 0 || $('.js-check-zipcode:hover').length > 0 || $('.js-search-bank-button:hover').length > 0 || $('.js-query:hover').length > 0) {
			return;
		}

		//サーバーサイドエラーを問答無用で削除する
		SMS_AUTH.field.deleteServerErrorMessage($targetItem, $targetTxtError);

		if ($(event.target).is(':disabled') || !$targetItem.hasClass('required') || $(event.target).hasClass('optional') || $(event.target).prop('tagName') === 'A') {
			return;
		}

		//[input="text"] or [input="radio"] or select or textareaか判定する
		var fieldType = this.judgeFormType($(event.target));

		var errorClassName = SMS_AUTH.field.getErrorClassName($(event.target), fieldType);
		if (!errorClassName) {
			return
		}
		//例外：複数のfieldに対して一つしかエラー出力しない場合（「名前」「電話番号」）
		if ($('.' + errorClassName).length > 1 && fieldType === 'text') {
			SMS_AUTH.field.multiItemValidate($('.' + errorClassName), $(event.target), errorClassName);
		}
		//通常：一つのfieldに対して一つのエラー出力
		else {
			SMS_AUTH.field.deleteErrorMessage(errorClassName, fieldType);

			//必須項目だったら空白チェックをする
			var requiredFlag = this.isRequired($(event.target).closest('.item'));

			if (requiredFlag) {
        if ($target.val() == false) {
          this.deleteErrorMessageDup($target);
        }
				var emptyFlag = this.isEmpty($(event.target), fieldType);
				this.validate($(event.target), emptyFlag, true);
			}

			//桁数チェック
			if ($(event.target).attr('minlength') && $(event.target).attr('maxlength')) {
				var lengthFlag = SMS_AUTH.field.hasLengthLimit($(event.target), $(event.target).attr('minlength'), $(event.target).attr('maxlength'));

				if (!lengthFlag) {
        this.deleteErrorMessageDup($target);
					this.validate($(event.target), lengthFlag, false);
				}
			}

      //生年月日チェック
      if (fieldType === "select" && $($target).val() ==="placeholder") {
        $($target).addClass('error');
        $($targetItem).closest('.item').toggleClass('error',$($target).closest('.item').find('select').hasClass('error'));
        this.generateErrorMessage($($targetTxtError), errorClassName, fieldType, 0);
      }

      if ( $('.validate-password').length && $('.validate-password-dup').length ) {
        if ( $('.validate-password').val() != "" && $('.validate-password-dup').val() != "" ) {
          if ( !($('.validate-password').closest('.item').find('.txtError li').length) && !($('.validate-password-dup').closest('.item').find('.txtError li').length) ) {
            var first_password = $('.validate-password').val();
            var second_password = $('.validate-password-dup').val();
            if (first_password !== second_password) {
              $('.validate-password-dup').addClass('error');
              $('.validate-password').closest('.item').addClass('error');
              $('.validate-password').closest('.item').find('.txtError').append('<li class="error_password-duplication">パスワードが一致しません。入力し直してください</li>');
            }else if( first_password === second_password ) {
              $('.validate-password').closest('.item').removeClass('error');
              $('.validate-password').closest('.item').find('.txtError').empty();
              $('.validate-password-dup').removeClass('error');
            }
          }
        }
      }

      //dupエラー発生時のfocusoutイベント時エラーメッセージを消さないようにする
      if ( $('.error_password-duplication').length) {
        $('.validate-password').closest('.item').addClass('error');
        $('.validate-password-dup').addClass('error');
      }

      console.log($(event.target));
			if($(event.target).hasClass('validate-numeric-only')){
				var numFlag = this.isNumericOnly($(event.target));
				console.log(numFlag);
			}

		}

		//エラーの数を見て、padding-topを調整する
		SMS_AUTH.field.adjustPadding($targetTxtError.find('li').length, $targetItem);
		//出力されたエラーの順番を制御する
		SMS_AUTH.field.sortErrorMessage(event.target, $targetItem, $targetTxtError);

	},

	multiItemValidate: function(_$target, _element, _errorClassName) {
		var flag = true;
		var emptyFlag = this.isEmpty(_element, 'text');

		//errorクラスを付与する
		_element.toggleClass('error', !emptyFlag);
		_element.closest('.item').toggleClass('error', _element.closest('.item').find('input, radio').hasClass('error'));

		_$target.each(function() {
			if ($(this).hasClass('error')) {
				flag = false;
			}
		});

		//エラー出力 / エラー削除
		if (!flag) {
			this.generateErrorMessage(_element.closest('.item').find('.txtError'), _errorClassName, 'text', 0);
		} else {
			this.deleteErrorMessage(_errorClassName, 'text');
		}
	},

	validateAll: function() {
		var form = document.querySelector('form');
		var formItem = form.querySelectorAll('input, select, textarea');

		Array.prototype.slice.call(formItem).forEach(function(target, index) {

			//非表示に関してはバリデーションの処理を走らせない
			if ($(target).parents('.item').is(':hidden') || $(target).hasClass('optional') || $(target).hasClass('readonly')) {
				return;
			}
			if ($(target).is(':hidden') && $(target).hasClass('validate-select-supply')) {
				return;
			}

			var fieldType = SMS_AUTH.field.judgeFormType($(target));
			if (!fieldType) {
				return;
			}
			var errorClassName = SMS_AUTH.field.getErrorClassName($(target), fieldType);
			if (!errorClassName) {
				return;
			}
			//必須項目かどうかチェックする
			var requiredFlag = SMS_AUTH.field.isRequired($(target).closest('.item'));

			//例外：複数のfieldに対して一つしかエラー出力しない場合（「名前」「電話番号」）

			if ($('.' + errorClassName).length > 1 && fieldType === 'text') {
				if (requiredFlag) {
					//必須チェック
					SMS_AUTH.field.multiItemValidate($('.' + errorClassName), $(target), errorClassName);

					//「ヲ」が使われていた場合
					if ($(target).hasClass('kata-wo')) {
						var kataWoFlag = SMS_AUTH.field.hasKataWo(target);
						if (!kataWoFlag) {
							SMS_AUTH.field.validate($(target), kataWoFlag, false);
						}
					}

					//桁数チェック
					if (!$(target).attr('minlength') && !$(target).attr('maxlength')) {
						return;
					}
					var lengthFlag = SMS_AUTH.field.hasLengthLimit($(target), $(target).attr('minlength'), $(target).attr('maxlength'));
					if (!lengthFlag) {
						SMS_AUTH.field.validate($(target), lengthFlag, false);
					}
				}
			}
			//通常：一つのfieldに対して一つのエラー出力
			else {
				//必須チェック
				if (requiredFlag) {
					var emptyFlag = SMS_AUTH.field.isEmpty($(target), fieldType);
					SMS_AUTH.field.validate($(target), emptyFlag, true);
				}

				//「ヲ」が使われていた場合
				if ($(target).hasClass('kata-wo')) {
					var kataWoFlag = SMS_AUTH.field.hasKataWo(target);
					if (!kataWoFlag) {
						SMS_AUTH.field.validate($(target), kataWoFlag, false);
					}
				}

				//mail形式チェック
				var mailFlag = SMS_AUTH.field.isMailFormat($(target).val());
				if ($(target).hasClass('email') && !mailFlag) {
					SMS_AUTH.field.validate($(target), mailFlag, false);
				}

				//一致チェック
				if ($(target).hasClass('validate-mail-match')) {
					var matchMailFlag = SMS_AUTH.field.isMatch($(target).val(), $('.email').val());
					if (!matchMailFlag) {
						SMS_AUTH.field.validate($(target), matchMailFlag, false);
					}
				}

				//「住所を検索する」ボタンをクリックしているかチェック
				if ($(target).hasClass('validate-zipcode')) {
					//桁数チェック
					if (!$(target).attr('minlength') && !$(target).attr('maxlength')) {
						return;
					}
					var lengthFlag = SMS_AUTH.field.hasLengthLimit($(target), $(target).attr('minlength'), $(target).attr('maxlength'));
					if (!lengthFlag) {
						SMS_AUTH.field.validate($(target), lengthFlag, 'zipcode');
					}

					var anotherAddressDisplayFlag = SMS_AUTH.field.AnotherAddressBlockExists();

					if (!anotherAddressDisplayFlag) {
						SMS_AUTH.field.validate($('.validate-zipcode'), anotherAddressDisplayFlag, false);
					}
				}

				//桁数チェック
				if (!$(target).attr('minlength') && !$(target).attr('maxlength')) {
					return;
				}
				var lengthFlag = SMS_AUTH.field.hasLengthLimit($(target), $(target).attr('minlength'), $(target).attr('maxlength'));
				if (!lengthFlag) {
					SMS_AUTH.field.validate($(target), lengthFlag, false);
				}

				// パスワードに半角英字と半角数字の組み合わせかチェック
				if($(target).hasClass('validate-password')) {

					if(!/^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,}$/.test($(target).val())) {
						$(target).addClass('validate-password-format');
						SMS_AUTH.field.validate($(target), false, false);
					}

				}

        // 一致チェック(パスワード)
				if ($(target).hasClass('validate-password-dup')) {
          var error_exist = false;
          if ( $('.validate-password').closest('.item').find('.txtError li').length && $('.validate-password-dup').closest('.item').find('.txtError li').length ) {
            error_exist = true;
          }
					if (!error_exist) {
            var first_password = $('.validate-password').val();
            var second_password = $(target).val();
            if (first_password !== second_password) {
              $('.validate-password-dup').addClass('error');
              $('.validate-password').closest('.item').addClass('error');
              $('.validate-password').closest('.item').find('.txtError').append('<li class="error_password-duplication">パスワードが一致しません。入力し直してください</li>');
            }
					}
				}

        if ( $(target).hasClass('sbpassword-check') ) {
          var _value = $(target).val();
          var validateSbidCheckError = false;
          var lengthFlag = SMS_AUTH.field.hasLengthLimit($(target), $(target).attr('minlength'), $(target).attr('maxlength'));
          var hankakuFlag = SMS_AUTH.field.isHankakuNumAlphaSymbol(_value);
          var stringTypeNum = 0;
          if ( SMS_AUTH.field.isHankakuNum(_value) == true) stringTypeNum++;
          if ( SMS_AUTH.field.isHankakuAlpha(_value) == true) stringTypeNum++;
          if ( SMS_AUTH.field.isHankakuSymbol(_value) == true) stringTypeNum++;
          if ( lengthFlag == false || hankakuFlag == false || stringTypeNum < 2 ) {
            validateSbidCheckError = true;
          }
          SMS_AUTH.field.validate($(target), !validateSbidCheckError, true);
        }

			}
		});

		//エラーの数を見て、padding-topを調整する
		$('.item').each(function() {
			var $errorLength = $(this).find('.txtError li').length;
			SMS_AUTH.field.adjustPadding($errorLength, $(this));
		});
	},

	validate: function(_$target, _errorConditions, _requiredFlag) {
		var $targetItem = _$target.closest('.item');
		var $targetTxtError = _$target.closest('.item').find('.txtError');
		var $targetTxtErrorList = _$target.closest('.item').find('.txtError li');
		var $errorLength = $targetTxtErrorList.length;

		//[input="text"] or [input="radio"] or selectか判定する
		var fieldType = this.judgeFormType(_$target);

		//errorクラスを付与する
		_$target.toggleClass('error', !_errorConditions);
		$targetItem.toggleClass('error', $targetItem.find('input, select, textarea').hasClass('error'));

		//errorMessageObjのkeyになるクラス名を取得する
		var errorClassName = this.getErrorClassName(_$target, fieldType);

		if (!errorClassName) {
			return;
		}

		//errorクラスある→エラー出力 / errorクラスない→エラー削除
		if (_$target.hasClass('error')) {
			var messageLength = errorMessageObj[fieldType][errorClassName]['message'].length;
			var index = _requiredFlag ? 0 : messageLength - 1
			index = _requiredFlag === 'zipcode' ? 0 : index;

			this.generateErrorMessage($targetTxtError, errorClassName, fieldType, index);

		} else {
			this.deleteErrorMessage(errorClassName, fieldType);
		}
	},

	//errorMessageObjからエラーテキストを取得する
	getErrorClassName: function(_$target, _formType) {
		if (!_$target) {
			return;
		}

		if (!_formType) {
			return;
		}

		var result = ''
		_$target.each(function() {
			var element = $(this)
			Object.keys(errorMessageObj[_formType]).forEach(function(_className) {
				if (element.hasClass(_className)) {
					result = _className;
				}
			});
		});
		return result;
	},

	generateErrorMessage: function(_txtError, _class, _formType, _priority) {
		var errorClass = errorMessageObj[_formType][_class];
		var msg = errorClass['message'][_priority];


		if (errorClass['display'] === true) {
			return;
		}
		_txtError.append('<li class="error_' + _class + '">' + msg + '</li>');
		errorClass['display'] = true;
	},

  deleteErrorMessageDup: function functionName(target) {
    if ($(target).hasClass('validate-password-dup') && $('.error_password-duplication').length ) {
      $('.validate-password').closest('.item').removeClass('error');
    }
    if ( $('.error_password-duplication').length ) {
      $('.validate-password').closest('.item').find('.txtError').empty();
      $('.validate-password-dup').removeClass('error');
    }
  },

	deleteServerErrorMessage: function(_item, _txtError) {
		_txtError.find('li').each(function() {
			if (!$(this).attr('class')) {
				$(this).remove();
				if (_txtError.find('li').length === 0) {
					_item.find('input, select, textarea').removeClass('error');
				}
				_item.toggleClass('error', _item.find('input, select, textarea').hasClass('error'));
			}
		});
	},

	deleteErrorMessage: function(_class, _fieldType) {
		if (!_class || _class === '') {
			return;
		}
		var $targetItem = $('.' + _class).closest('.item');

		$('.error_' + _class).remove();
		$('.' + _class).removeClass('error');
		$targetItem.toggleClass('error', $targetItem.find('input, select, textarea').hasClass('error'));
		errorMessageObj[_fieldType][_class]['display'] = false;
	},

	deleteErrorMessageAll: function() {
		$('.txtError').empty();
		$('.formReset').find('input, select, textarea').removeClass('error');
		Object.keys(errorMessageObj).forEach(function(_formType) {
			Object.keys(errorMessageObj[_formType]).forEach(function(_class) {
				errorMessageObj[_formType][_class]['display'] = false;
			});
		});
		$('.item').removeClass('error');
	},

	scrollErrorTop: function() {
		if ($('.txtError').find('li').length < 1) {
			return;
		}

		var targetPosition = $('.txtError:visible').eq(0).offset().top;
		$('html, body').animate({
			scrollTop: targetPosition
		}, 300, 'swing');
	},

	scrollTargetError: function(_target) {
		if (_target.closest('.item').find('.txtError li').length > 0) {
			$('html, body').animate({
				scrollTop: _target.closest('.item').find('.txtError').eq(0).offset().top
			}, 300, 'swing');
		}
	},

	scrollTargetServerError: function(_target) {
		if (_target.closest('.item').find('.txtError li').length > 0) {
			$('html, body').animate({
				scrollTop: _target.closest('.item').find('.txtError').eq(0).offset().top - 100
			}, 300, 'swing');
		}
	},

	// [input="text"] or [input="radio"] or [input="password"] or selectか textareaか判定する
	judgeFormType: function(_$target) {
		if (_$target.prop('tagName') === 'INPUT') {
			if (_$target.attr('type') === 'text' || _$target.attr('type') === 'tel' || _$target.attr('type') === 'password') {
				return 'text';
			} else if (_$target.attr('type') === 'radio') {
				return 'radio';
			}
		} else if (_$target.prop('tagName') === 'SELECT') {
			return 'select';
		} else if (_$target.prop('tagName') === 'TEXTAREA') {
			return 'text';
		}
	},

	// エラーの数によってpadding調整クラスを付与して表示崩れを防ぐ
	adjustPadding: function(_errorLength, _targetItem) {
		if (_errorLength < 1) {
			return;
		}

		var paddingClassList = ['item-padding-01', 'item-padding-02', 'item-padding-03', 'item-padding-04'];

		var targetRemoveClass = '';
		var targetAddClass = '';

		paddingClassList.forEach(function(paddingClass) {
			if (_targetItem.hasClass(paddingClass)) {
				targetRemoveClass = paddingClass;
			}
		});

		_targetItem.removeClass(targetRemoveClass);

		targetAddClass = paddingClassList[_errorLength - 1];
		_targetItem.addClass(targetAddClass);
	},

	sortErrorMessage: function(_target, _targetItem, _errorList) {
		var sortList = [];
		var $formItem = _targetItem.find('input, select');

		$formItem.each(function() {
			if ($(this).is(':disabled') || $(this).hasClass('optional') || $(this).hasClass('readonly')) {
				return;
			}
			//[input="text"] or [input="radio"] or selectか判定する
			var fieldType = SMS_AUTH.field.judgeFormType($(this));

			if (!fieldType) {
				return;
			}

			//errorMessageObjのkeyになるクラス名を取得する
			var errorClassName = SMS_AUTH.field.getErrorClassName($(this), fieldType);
			sortList.push('error_' + errorClassName);
		});
		sortList.forEach(function(x) {
			$('.' + x).appendTo(_errorList);
		})
	},

	isRequired: function(_target) {
		return _target.hasClass('required') ? true : false;
	},

	isEmpty: function(_$target, _fieldType) {
		var $targetItem = _$target.closest('.item');

		if (_fieldType === 'radio') {
			if (!$targetItem.find('input[type=radio]:checked').val()) {
				return false;
			}
		} else {
			if (!_$target.val()) {
				return false;
			}
		}
		return true;
	},

	isNumericOnly: function(_target){
		console.log(_target.val());
		if(_target.val()=="" ||  _target.val().match(/[^\d]/)){
			return false;
		}
		return true;
	},


	hasLengthLimit: function(_$target, _min, _max) {
		if (_$target.val().length < _min && _min) {
			return false;
		}
		if (_$target.val().length > _max && _max) {
			return false;
		}
		return true;
	},

	hasKataWo: function(_target) {
		return ($(_target).val().indexOf('ヲ') === -1) ? true : false;
	},

	isMailFormat: function(_value) {
		if (_value.match(/^[a-zA-Z0-9@!#$%&"'*+\\/=?^_`{|}~-][a-zA-Z0-9 @.!#$%&"'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i)) {
			return true;
			``
		} else {
			return false;
		}
	},

	isMatch: function(_value1, _value2) {
		return _value1 === _value2 ? true : false;
	},
  isHankakuNumAlphaSymbol: function(_value) {
    if (_value.match(/[^A-Za-z0-9-!"#$%&'()=<>,.?_\[\]{}@^~\-\\|:;*+/`]/g)) {
      return false;
    } else {
      return true;
    }
  },
  isHankakuNum: function(_value) {
    if (_value.match(/[0-9]/g)) {
      return true;
    } else {
      return false;
    }
  },
  isHankakuAlpha: function(_value) {
    if (_value.match(/[A-Za-z]/g)) {
      return true;
    } else {
      return false;
    }
  },
  isHankakuSymbol: function(_value) {
    if (_value.match(/[-!"#$%&'()=<>,.?_\[\]{}@^~\-\\|:;*+/`]/g)) {
      return true;
    } else {
      return false;
    }
  },

	AnotherAddressBlockExists: function() {
		return $('.another-address-inner-area').eq('0').children().length > 0 ? true : false;
	},

	//支援先のバリデーション
	validateSupportArea: function() {
		if ($('.support-project-area:visible').length < 1) {
			return;
		}

		var $targetItem = $('.validate-support-area').parents('.item');
		var $radioBox = $('.js-check-radio.checked').find('input[type=radio]');
		var $textError = $targetItem.find('.txtError');
		var errorMessage = '';

		if ($radioBox.val()) {
			//チェックされている時
			$radioBox.removeClass('error');
			$targetItem.removeClass('error');
			SMS_AUTH.field.deleteErrorMessage('validate-support-project', 'radio');
		} else {
			//チェックされてない時
			$radioBox.addClass('error');
			$targetItem.addClass('error');
			SMS_AUTH.field.generateErrorMessage($textError, 'validate-support-project', 'radio', 0);
		}

		//エラーの数を見て、padding-topを調整する
		SMS_AUTH.field.adjustPadding($textError.find('li').length, $targetItem);
	}

}
window.SMS_AUTH = SMS_AUTH;

$(function() {
	SMS_AUTH.field.init();

	// Enterキーによるフォーム送信を抑制
	$(document).on('keypress', 'input:not([type=submit])', function(e) {

		return e.which !== 13;
	});

	// ページロード時にエラー位置にスクロール
	setTimeout(function() {
		var $errorField = $('.item ul.txtError li').filter(':first');
		var $errorItem = $errorField.parents('.item');
		SMS_AUTH.field.adjustPadding($errorField.length, $errorItem);
		SMS_AUTH.field.scrollTargetServerError($errorField);
	}, 900);
});



// WEBPACK FOOTER //
// ./src/shared/main_validate.js